import { render } from "./sendForm.vue?vue&type=template&id=3ff1c09d"
import script from "./sendForm.vue?vue&type=script&lang=js"
export * from "./sendForm.vue?vue&type=script&lang=js"

import "./sendForm.vue?vue&type=style&index=0&id=3ff1c09d&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__